import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    tabindex: "-1",
    "aria-hidden": "true",
    class: "fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full bg-darkend"
};
const _hoisted_2 = { class: "flex items-center justify-center h-screen" };
const _hoisted_3 = ["onSubmit"];
const _hoisted_4 = { class: "relative bg-white rounded-lg shadow dark:bg-gray-700" };
const _hoisted_5 = { class: "p-6 space-y-6" };
const _hoisted_6 = { class: "block" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "text-grey-300 text-xs" }, "Liste der Rezept-Nummern:", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", { class: "text-grey-300 text-xs" }, " Auf der Calcmenu Seite 'Exportieren - Rezept', den Text unter 'Nummer' und 'Markierte Einträge' kopieren und oben einfügen.", -1);
const _hoisted_9 = { class: "block" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("span", { class: "text-grey-300 text-xs" }, "Sprache:", -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("option", { value: "2" }, "Deutsch", -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("option", { value: "3" }, "Französisch", -1);
const _hoisted_13 = [
    _hoisted_11,
    _hoisted_12
];
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CalmenuComponent',
    emits: ["submitCalmenuForm"],
    setup(__props, { emit: emits }) {
        const textareaContent = ref('');
        const language = ref('2');
        const submitForm = () => {
            emits('submitCalmenuForm', textareaContent.value, language.value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, {
                name: "modal",
                "enter-from-class": "opacity-0",
                "enter-to-class": "opacity-100",
                "leave-from-class": "opacity-100",
                "leave-to-class": "opacity-0",
                "enter-active-class": "ease-out duration-300",
                "leave-active-class": "ease-in duration-300"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("form", {
                                onSubmit: _withModifiers(submitForm, ["prevent"]),
                                class: "relative w-full h-full max-w-2xl md:h-auto"
                            }, [
                                _createElementVNode("div", _hoisted_4, [
                                    _renderSlot(_ctx.$slots, "header"),
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("label", _hoisted_6, [
                                            _hoisted_7,
                                            _withDirectives(_createElementVNode("textarea", {
                                                rows: "10",
                                                cols: "58",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((textareaContent).value = $event))
                                            }, null, 512), [
                                                [_vModelText, textareaContent.value]
                                            ])
                                        ]),
                                        _hoisted_8,
                                        _createElementVNode("label", _hoisted_9, [
                                            _hoisted_10,
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((language).value = $event)),
                                                class: "mt-1 block w-full"
                                            }, _hoisted_13, 512), [
                                                [_vModelSelect, language.value]
                                            ])
                                        ])
                                    ]),
                                    _renderSlot(_ctx.$slots, "footer")
                                ])
                            ], 40, _hoisted_3)
                        ])
                    ])
                ]),
                _: 3
            }));
        };
    }
});
